import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { RadioButton } from '_components';
import styles from './Header.module.css';

class PatientCareCenterNoteHeaderNoteType extends React.Component {

    convert(type) {
        if (type !== this.props.noteType) {
            this.props.convert(this.props.noteId, type);
        }
    }


    render() {
        if (this.props.noteType === 1) {
            return (<span />);
        } else {
            return (
                <div className={styles.type_wrapper}>
                    <RadioButton
                        size='extra-small'
                        className={styles.radio}
                        label='Daily Note'
                        onClick={() => this.convert(2)}
                        disabled={this.props.isPocDue || this.props.isProgressDue || this.props.authStatus === 3}
                        selected={this.props.noteType === 2 ? true : false}
                    />
                    <RadioButton
                        size='extra-small'
                        className={styles.radio}
                        label='Progress Note'
                        onClick={() => this.convert(3)}
                        selected={this.props.noteType === 3 ? true : false}
                    />
                    <RadioButton
                        size='extra-small'
                        className={styles.radio}
                        label='Progress Note/Daily Note'
                        onClick={() => this.convert(5)}
                        selected={this.props.noteType === 5 ? true : false}
                    />
                    <RadioButton
                        size='extra-small'
                        className={styles.radio}
                        label='Discharge'
                        onClick={() => this.convert(4)}
                        selected={this.props.noteType === 4 ? true : false}
                    />
                    <RadioButton
                        size='extra-small'
                        className={styles.radio}
                        label='Discharge/Daily Note'
                        onClick={() => this.convert(6)}
                        selected={this.props.noteType === 6 ? true : false}
                    />
                    {this.props.isPeds && this.props.isPedsEnabled &&
                        <RadioButton
                            size='extra-small'
                            className={styles.radio}
                            label='Missed Visit'
                            onClick={() => this.convert(22)}
                            selected={this.props.noteType === 22 ? true : false}
                        />}
                </div>
            );
        }
    }
}


function mapDispatchToProps(dispatch) {
    return {
        convert: bindActionCreators(noteActions.convert, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;

    //get note warnings 

    let isProgressDue = state.entities.admissions[epno].isProgressDue;
    let isPocDue = state.entities.admissions[epno].isPocDue;
    let authStatus = state.entities.admissions[epno].authStatus;
    let isPeds = state.entities.admissions[epno].isPeds;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['SAPPHIRE_PEDS_ENABLED'].PRVALUE === 'true' : false;
    if (state.entities.notes.NoteWarnings !== undefined) {
        if (state.entities.notes.NoteWarnings[noteId] !== undefined) {
            isProgressDue = state.entities.notes.NoteWarnings[noteId].ISPROGRESSDUE === undefined ? state.entities.admissions[epno].isProgressDue : state.entities.notes.NoteWarnings[noteId].ISPROGRESSDUE;
            isPocDue = state.entities.notes.NoteWarnings[noteId].ISPOCDUE === undefined ? state.entities.admissions[epno].isPocDue : state.entities.notes.NoteWarnings[noteId].ISPOCDUE;
            authStatus = state.entities.notes.NoteWarnings[noteId].ISPOCDUE === undefined ? state.entities.admissions[epno].authStatus : state.entities.notes.NoteWarnings[noteId].ISPOCDUE;
        }
    }

    let isFederal = state.entities.admissions[epno].isFederal;
    let isWc = state.entities.admissions[epno].isWc;

    // clear for commercial payers
    if (isProgressDue && !isFederal && !isWc && (!isPeds || !isPedsEnabled)) {
        isProgressDue = false;
    }

    // clear for everyone but federal
    if (isPocDue && !isFederal) {
        isPocDue = false;
    }

    return {
        noteId,
        noteType,
        pk,
        isProgressDue,
        isPocDue,
        authStatus,
        isPeds,
        isPedsEnabled
    };
}

const connectedPatientCareCenterNoteHeaderNoteType = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteHeaderNoteType);
export { connectedPatientCareCenterNoteHeaderNoteType as PatientCareCenterNoteHeaderNoteType };

